export default __webpack_public_path__ + "static/media/business1.df007df6.jpg";